"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var inputUtils_1 = require("../../core/inputUtils");
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'language', 'experiments'], function (_a) {
    var _b;
    var compData = _a.compData, compProps = _a.compProps, language = _a.language, experiments = _a.experiments;
    var isGoogleMapsProvider = !!compData.googleMapsApiKey ||
        !experiments['specs.thunderbolt.addressInputAtlasProvider'];
    return {
        placeholder: compData.placeholder,
        readOnly: compProps.readOnly,
        required: compProps.required,
        isDisabled: compProps.isDisabled,
        iconVisible: compProps.iconVisible,
        dividerVisible: compProps.dividerVisible,
        googleMapsApiKey: compData.googleMapsApiKey,
        country: (_b = compData.filter) === null || _b === void 0 ? void 0 : _b.country,
        alignment: compProps.alignment,
        lang: language,
        label: compData.label,
        provider: isGoogleMapsProvider ? 'googleMaps' : 'atlas',
    };
});
var alignmentCssVars = function (alignment, labelPadding) {
    return __assign(__assign({ '--textAlign': alignment }, (alignment === 'right'
        ? {
            '--dir': 'rtl',
        }
        : {
            '--dir': 'ltr',
        })), (alignment === 'right'
        ? {
            '--labelPadding': "0 " + labelPadding + "px 0 0",
        }
        : alignment === 'center'
            ? {
                '--labelPadding': '0',
            }
            : {
                '--labelPadding': "0 0 0 " + labelPadding + "px",
            }));
};
exports.css = withCompInfo_1.withCompInfo(['styleProperties', 'compProps', 'compData', 'compLayout', 'isMobileView'], function (_a, cssVars) {
    var styleProperties = _a.styleProperties, compProps = _a.compProps, compData = _a.compData, compLayout = _a.compLayout, isMobileView = _a.isMobileView;
    var label = compData.label;
    var labelMargin = compProps.labelMargin, labelPadding = compProps.labelPadding, alignment = compProps.alignment;
    return __assign(__assign(__assign(__assign({}, cssVars), { '--dropdownOptionPadding': styleProperties.dropdownOptionPadding + "px" }), alignmentCssVars(alignment, labelPadding)), { '--labelMarginBottom': !label ? '0' : labelMargin + "px", '--inputHeight': inputUtils_1.getInputHeightInPx({
            compProps: compProps,
            compLayout: compLayout,
            isMobileView: isMobileView,
        }) });
});
//# sourceMappingURL=AddressInput.js.map